var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { isMobile } from '../../utils/media';
import Link from '../Link/Link';
import News from '../News/News';
import Search from '../Search/Search';
import Tooltip from '../Tooltip/Tooltip';
import { debounce } from './Banner.functions';
/** Assets */
import './Banner.scss';
/**
 * Banner component
 */
var Banner = /** @class */ (function (_super) {
    __extends(Banner, _super);
    /**
     * Banner constructor
     *
     * @param props
     */
    function Banner(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Open or close services list
         */
        _this.toggleTooltip = function () {
            var tooltipIsVisible = _this.state.tooltipIsVisible;
            _this.setState({ tooltipIsVisible: !tooltipIsVisible });
        };
        /**
         * Handle click on connexion part (logged menu and logged ou menu)
         *
         * @param id
         * @param evt
         */
        _this.handleClick = function (id, evt) {
            var menuDisplay = _this.state.menuDisplay;
            var index = menuDisplay.findIndex(function (link) { return link.id === id; });
            if (_this.props.getLinkUrlParams) {
                var urlParameters = _this.props.getLinkUrlParams(menuDisplay[index].url);
                if (evt && urlParameters) {
                    evt.preventDefault();
                    switch (urlParameters.type) {
                        case 'redirect':
                            _this.props.history.push(menuDisplay[index].url + "?" + encodeURIComponent(urlParameters.payload));
                            break;
                        default:
                            break;
                    }
                }
            }
            if (index && menuDisplay[index].type === 'menu_logged') {
                menuDisplay[index].activeIndex = index;
                _this.setState({ menuDisplay: menuDisplay });
            }
        };
        /**
         * Handle click on children on menu logged and logged out
         */
        _this.handleAdditionalMenuClick = function () {
            if (isMobile()) {
                var additionMenuIsVisible = _this.state.additionMenuIsVisible;
                _this.setState({ additionMenuIsVisible: !additionMenuIsVisible });
            }
        };
        /**
         * Return search placeholder
         */
        _this.getSearchPlaceholder = function () {
            var searchConfig = _this.props.searchConfig;
            return searchConfig && typeof searchConfig.placeholder !== 'undefined'
                ? searchConfig.placeholder
                : 'Votre recherche...';
        };
        /**
         * Handle key press on mobile menu
         *
         * @param evt
         */
        _this.handleKeyUpOnMobileMenu = function (evt) {
            if (evt.keyCode === 40 || evt.keyCode === 13) {
                _this.props.toggleMobileMenu();
            }
        };
        /**
         * Handle key press on logo
         *
         * @param evt
         */
        _this.handleKeyUpOnLogo = function (evt) {
            if (evt.keyCode === 40 || evt.keyCode === 13) {
                _this.toggleTooltip();
            }
        };
        /**
         * Handle key press on additional menu
         *
         * @param evt
         */
        _this.handleKeyUpOnAdditionalMenu = function (evt) {
            if (evt.keyCode === 40 || evt.keyCode === 13) {
                _this.handleAdditionalMenuClick();
            }
        };
        _this.state = {
            additionMenuIsVisible: false,
            connexionMenuIsOpen: false,
            menuDisplay: props.menu,
            tooltipIsVisible: false,
        };
        return _this;
    }
    Banner.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.menu !== prevProps.menu) {
            this.setState({ menuDisplay: this.props.menu });
        }
    };
    /**
     * Component initialization
     */
    Banner.prototype.componentDidMount = function () {
        var _this = this;
        if (window) {
            window.addEventListener('resize', debounce(function () {
                _this.setState({});
            }));
        }
    };
    /**
     * Component render
     */
    Banner.prototype.render = function () {
        var _this = this;
        var menuDisplay = this.state.menuDisplay;
        var _a = this.props, news = _a.news, services = _a.services, mobileMenuIsOpen = _a.mobileMenuIsOpen, toggleMobileMenu = _a.toggleMobileMenu, isLogged = _a.isLogged, searchConfig = _a.searchConfig;
        var _b = this.state, tooltipIsVisible = _b.tooltipIsVisible, additionMenuIsVisible = _b.additionMenuIsVisible;
        return (React.createElement("div", { id: "banner", className: "glxy-container" + (mobileMenuIsOpen ? ' isOpen' : '') + "\n        " + (isLogged ? ' isLogged' : '') },
            isMobile() ? (React.createElement("div", { role: "button", className: "toggle-mobile-menu", onClick: toggleMobileMenu, "aria-label": "Ouvrir le menu", onKeyUp: this.handleKeyUpOnMobileMenu, tabIndex: 0 })) : null,
            React.createElement("div", { "arial-label": "Ouvrir menu des sites digisSchool", className: "logo", role: "button", onClick: this.toggleTooltip, onKeyUp: this.handleKeyUpOnLogo, tabIndex: 0 },
                React.createElement("div", { className: "image" }),
                React.createElement("div", { className: "caret" })),
            tooltipIsVisible ? React.createElement(Tooltip, { services: services, onClickToggle: this.toggleTooltip }) : null,
            news.length ? React.createElement(News, { menu: news }) : null,
            searchConfig && searchConfig.enabled ? React.createElement(Search, { placeholder: this.getSearchPlaceholder() }) : null,
            menuDisplay.length ? (React.createElement("div", { role: "button", "aria-label": "Ouvrir menu de connexion", className: (additionMenuIsVisible ? 'isOpen ' : '') + "additional-menu", onClick: this.handleAdditionalMenuClick, onKeyUp: this.handleKeyUpOnAdditionalMenu, tabIndex: 0 },
                React.createElement("ul", null, menuDisplay.map(function (row, index) { return (React.createElement(Link, { key: row.id, linkId: row.id, level: row.level, index: index, label: row.title, children: row.__children, url: row.url, image: row.imageFilename, onClickAction: _this.handleClick, activeIndex: row.activeIndex, slug: row.slug, target: row.target, columnType: row.columnType })); })))) : null));
    };
    return Banner;
}(React.Component));
export default withRouter(Banner);
//# sourceMappingURL=Banner.js.map